import { Globals } from '../../modules/Globals';
import axios from 'axios';
import ICollection from '../../interfaces/ICollection';

const apiUrl = Globals.apiPath + '/collections';

export default class CollectionsService {
  constructor() {}

  async getAll(): Promise<ICollection[]> {
    let res = await axios.get<ICollection[]>(apiUrl);
    return res.data;
  }

  async getById(id: number): Promise<ICollection> {
    let res = await axios.get<ICollection>(`${apiUrl}/${id}`);
    return res.data;
  }

  async getByToken(token: string): Promise<ICollection> {
    let res = await axios.get<ICollection>(`${apiUrl}/t/${token}`);
    return res.data;
  }

  async create(collection: ICollection): Promise<ICollection> {
    let res = await axios.post<ICollection>(apiUrl, collection);
    return res.data;
  }

  async update(collection: ICollection): Promise<ICollection> {
    let res = await axios.put<ICollection>(
      `${apiUrl}/${collection.id}`,
      collection
    );
    return res.data;
  }

  async delete(collection: ICollection): Promise<ICollection> {
    let res = await axios.put<ICollection>(`${apiUrl}/${collection.id}`);
    return res.data;
  }
}
